import { Coffee, Play, Loader2 } from "lucide-react";
import { fmtClock } from "./kioskUtils";

export const BreakControls = ({ onBreak, breakSince, busy, onStart, onEnd }) => (
  onBreak ? (
    <div className="mb-4" data-testid="kiosk-on-break-banner">
      <div className="bg-amber-500/10 border border-amber-500/60 rounded-lg p-4 mb-3 text-amber-300 flex items-center gap-2">
        <Coffee size={18} /> On break since <span className="font-mono font-bold">{fmtClock(breakSince)}</span>
      </div>
      <button onClick={onEnd} disabled={busy}
        className="w-full py-5 bg-amber-400 hover:bg-amber-300 text-black text-xl font-bold rounded-lg flex items-center justify-center gap-3 disabled:opacity-60"
        data-testid="kiosk-end-break-btn">
        {busy ? <Loader2 size={22} className="animate-spin" /> : <Play size={22} />} End Break
      </button>
    </div>
  ) : (
    <button onClick={onStart} disabled={busy}
      className="w-full py-5 mb-4 bg-neutral-900 border-2 border-amber-400 text-amber-300 hover:bg-amber-400 hover:text-black text-xl font-bold rounded-lg flex items-center justify-center gap-3 disabled:opacity-60 transition-colors"
      data-testid="kiosk-start-break-btn">
      {busy ? <Loader2 size={22} className="animate-spin" /> : <Coffee size={22} />} Start Break
    </button>
  )
);
